export default [
  {
    date: '2023-10-01',
    thumb: '/gallery/highlights/highlight-1.jpg',
    title: { en: 'Neither...Nor…', hy: 'arm dolor sit amet', ru: 'rus dolor sit amet' },
    desc: {
      en: 'The composition "Neither...Nor…" won the first prize in the XVI. Francisco Escudero international competition. Zarautz, Spain, 2023.',
      hy: 'Arm Lorem ipsum dolor sit amet, consecteti adipiscing elit, sed do eiusmod.',
      ru: 'Rus Lorem ipsum dolor sit amet, consecteti adipiscing elit, sed do eiusmod.'
    },
    url: '/highlights/escudero'
  },
  {
    date: '2023-09-16',
    thumb: '/gallery/highlights/highlight-2.jpg',
    title: { en: 'Regensburg', hy: 'Die Kreuzigung Christi', ru: 'Die Kreuzigung Christi' },
    desc: {
      en: '2nd Prize and the audience sympathy award in Regensburg Composition Competition 2023',
      hy: 'Arm Lorem ipsum dolor sit amet, consecteti adipiscing elit, sed do eiusmod.',
      ru: 'Rus Lorem ipsum dolor sit amet, consecteti adipiscing elit, sed do eiusmod.'
    },
    url: '/highlights/regensburg'
  },
  {
    date: '2023-05-27',
    thumb: '/gallery/highlights/highlight-3.jpg',
    title: { en: '\"Mansurian"\ Competition', hy: 'arm goodbye, bird', ru: 'rus goodbye, bird' },
    desc: {
      en: '2nd prize in \"Mansurian"\ Competition in Yerevan, Armenia',
      hy: 'Arm Lorem ipsum dolor sit amet, consecteti adipiscing elit, sed do eiusmod.',
      ru: 'Rus Lorem ipsum dolor sit amet, consecteti adipiscing elit, sed do eiusmod.'
    },
    url: '/highlights/mansurian'
  }
];
